var map = {
	"./24-25/U15_24-25/Boros Barnabás.jpg": 988,
	"./24-25/U15_24-25/Csakmag Zalán.jpg": 6700,
	"./24-25/U15_24-25/Ficzere Márton.jpg": 1698,
	"./24-25/U15_24-25/Keserű Kolos.jpg": 7204,
	"./24-25/U15_24-25/Kiss Csongor.jpg": 834,
	"./24-25/U15_24-25/Kiss Gábor.jpg": 904,
	"./24-25/U15_24-25/Kovács Péter Áron.jpg": 1910,
	"./24-25/U15_24-25/László Jonathan.jpg": 1499,
	"./24-25/U15_24-25/Majoross Barnabás.jpg": 4257,
	"./24-25/U15_24-25/Meggyes Medárd.jpg": 4385,
	"./24-25/U15_24-25/Nagy Dániel.jpg": 4287,
	"./24-25/U15_24-25/Nádasy Bertalan.jpg": 4662,
	"./24-25/U15_24-25/Németh Erik.jpg": 4477,
	"./24-25/U15_24-25/Ritter Zsolt.jpg": 5005,
	"./24-25/U15_24-25/Somogyi Balázs.jpg": 7033,
	"./24-25/U15_24-25/Szabó Péter.jpg": 1056,
	"./24-25/U15_24-25/Tomkó Márton.jpg": 1618,
	"./24-25/U15_24-25/Vincze Botond.jpg": 7428,
	"./24-25/U15_24-25/Vonnák Máté.jpg": 7675,
	"./24-25/U15_24-25/team.jpg": 6748,
	"./24-25/U16_24-25/Bencic Mihajlo.jpg": 3432,
	"./24-25/U16_24-25/Betic Ronen.jpg": 7893,
	"./24-25/U16_24-25/Boroznaki Kadosa.jpg": 7822,
	"./24-25/U16_24-25/Brestovac Relja.jpg": 993,
	"./24-25/U16_24-25/Cságola Vince.jpg": 6347,
	"./24-25/U16_24-25/Gombos Zoltán.jpg": 2211,
	"./24-25/U16_24-25/Gál Konrád.jpg": 1835,
	"./24-25/U16_24-25/Góbi Péter.jpg": 105,
	"./24-25/U16_24-25/Gődény Zalán.jpg": 6416,
	"./24-25/U16_24-25/Jászai Dávid.jpg": 8930,
	"./24-25/U16_24-25/Kedves Zoltán.jpg": 1978,
	"./24-25/U16_24-25/Kemény-Savovic Milán.jpg": 3690,
	"./24-25/U16_24-25/Kiss-Karasszon Ádám.jpg": 1360,
	"./24-25/U16_24-25/Kujundzic Nikola.jpg": 5833,
	"./24-25/U16_24-25/Kóródi Zalán.jpg": 8260,
	"./24-25/U16_24-25/Martinovic Ognjen.jpg": 6757,
	"./24-25/U16_24-25/Matti Pylkas.jpg": 533,
	"./24-25/U16_24-25/Molnár Dániel.jpg": 2560,
	"./24-25/U16_24-25/Popov Novak.jpg": 8099,
	"./24-25/U16_24-25/Schulteisz Vince.jpg": 4131,
	"./24-25/U16_24-25/Seymour Daniel.jpg": 35,
	"./24-25/U16_24-25/Varga Mátyás.jpg": 2676,
	"./24-25/U16_24-25/Vónya-Tolner Ákos.jpg": 5926,
	"./24-25/U16_24-25/team.jpg": 4185,
	"./24-25/U16_24-25/Ábrahám Gábor.jpg": 69,
	"./24-25/U18_24-25/Aradi Kende.jpg": 3370,
	"./24-25/U18_24-25/Balazevic Andrej.jpg": 4861,
	"./24-25/U18_24-25/Buzás Tamás.jpg": 8183,
	"./24-25/U18_24-25/Bánhegyi Szabolcs.jpg": 2278,
	"./24-25/U18_24-25/Fockter Kadosa.jpg": 2091,
	"./24-25/U18_24-25/Gál Botond.jpg": 3764,
	"./24-25/U18_24-25/Halász Márk.jpg": 4796,
	"./24-25/U18_24-25/Jámbor Patrik.jpg": 282,
	"./24-25/U18_24-25/Jászai Barna.jpg": 9750,
	"./24-25/U18_24-25/Kornyilov Péter.jpg": 4143,
	"./24-25/U18_24-25/Kállay Mihály.jpg": 4042,
	"./24-25/U18_24-25/Káté Zoltán.jpg": 8953,
	"./24-25/U18_24-25/Lackó Attila.jpg": 5489,
	"./24-25/U18_24-25/Luciano Basile.jpg": 7995,
	"./24-25/U18_24-25/Mihályi Olivér.jpg": 7756,
	"./24-25/U18_24-25/Németh Huba.jpg": 7731,
	"./24-25/U18_24-25/Pákozdi Márk.jpg": 2317,
	"./24-25/U18_24-25/Schmidt Barnabás.jpg": 3890,
	"./24-25/U18_24-25/Szalontai-Virág István.jpg": 6534,
	"./24-25/U18_24-25/Szamel Barnabás.jpg": 238,
	"./24-25/U18_24-25/Szivák Gergő.jpg": 6884,
	"./24-25/U18_24-25/Tajti Dániel.jpg": 6421,
	"./24-25/U18_24-25/Temunovic Vanja.jpg": 2258,
	"./24-25/U18_24-25/Tornyos Benedek.jpg": 2224,
	"./24-25/U18_24-25/Tóth Flórián.jpg": 9692,
	"./24-25/U18_24-25/Urbányi Krisztián.jpg": 2679,
	"./24-25/U18_24-25/Varga Ákos.jpg": 6263,
	"./24-25/U18_24-25/team.jpg": 6955,
	"./24-25/U21_24-25/Abonyi_Trisztan.jpg": 4652,
	"./24-25/U21_24-25/Antal_Csongor.jpg": 4672,
	"./24-25/U21_24-25/Ballo_Janos.jpg": 9632,
	"./24-25/U21_24-25/Bekker_Endre.jpg": 1989,
	"./24-25/U21_24-25/Bisz_Mark.jpg": 9078,
	"./24-25/U21_24-25/Borsos_Barna.jpg": 2415,
	"./24-25/U21_24-25/Daradics_Akos.jpg": 1248,
	"./24-25/U21_24-25/Dobos_Boldizsar.jpg": 7660,
	"./24-25/U21_24-25/Jilly_Daniel.jpg": 5798,
	"./24-25/U21_24-25/Jurkovics_Bence.jpg": 1692,
	"./24-25/U21_24-25/Kiss_Daniel.jpg": 422,
	"./24-25/U21_24-25/Kiss_Peter.jpg": 6905,
	"./24-25/U21_24-25/Kozák Attila.jpg": 411,
	"./24-25/U21_24-25/Ladányi Balázs.jpg": 2411,
	"./24-25/U21_24-25/Lakatos Levente.jpg": 1510,
	"./24-25/U21_24-25/Lifhifts_Savelli.jpg": 1188,
	"./24-25/U21_24-25/Marton_Attila.jpg": 5767,
	"./24-25/U21_24-25/Menyhart_Mark.jpg": 1128,
	"./24-25/U21_24-25/Molnár Zétény.jpg": 8794,
	"./24-25/U21_24-25/Mozes_Mathe_Elemer.jpg": 5935,
	"./24-25/U21_24-25/Racz_Levente.jpg": 2812,
	"./24-25/U21_24-25/Ravasz Csanád.jpg": 5427,
	"./24-25/U21_24-25/Simic_Petar.jpg": 504,
	"./24-25/U21_24-25/Straubinger Zoltán.jpg": 5504,
	"./24-25/U21_24-25/Szecsi_Viktor.jpg": 8729,
	"./24-25/U21_24-25/Szlovicsak_Balazs.jpg": 6985,
	"./24-25/U21_24-25/Tihanyi_Oliver.jpg": 6294,
	"./24-25/U21_24-25/Toth_Domonkos.jpg": 5312,
	"./24-25/U21_24-25/Weidemann Márk.jpg": 8197,
	"./24-25/U21_24-25/Zambor_Akos.jpg": 4460,
	"./24-25/U21_24-25/Zsitva_Gergely.jpg": 8435,
	"./24-25/U21_24-25/team.jpg": 9995,
	"./24-25/noi_24-25/Benczenleitner Ottó.jpg": 306,
	"./24-25/noi_24-25/Bereczki Blanka.jpg": 9712,
	"./24-25/noi_24-25/Bátyi Boróka.jpg": 3501,
	"./24-25/noi_24-25/Carlotta Regine.jpg": 4124,
	"./24-25/noi_24-25/Chlepkó Zsófia.jpg": 1062,
	"./24-25/noi_24-25/Gergely Dalma.jpg": 972,
	"./24-25/noi_24-25/Gyula Rebeka.jpg": 3404,
	"./24-25/noi_24-25/Hajdu Lili.jpg": 408,
	"./24-25/noi_24-25/Horváth Maja.jpg": 1869,
	"./24-25/noi_24-25/Imets Mercédesz.jpg": 3056,
	"./24-25/noi_24-25/Ivona Lazic.jpg": 2052,
	"./24-25/noi_24-25/Kerkovits Réka.jpg": 6915,
	"./24-25/noi_24-25/Milibák Helga.jpg": 8674,
	"./24-25/noi_24-25/Nagy Richárd.jpg": 9342,
	"./24-25/noi_24-25/Németh Anikó.jpg": 5693,
	"./24-25/noi_24-25/Pásztor Flóra.jpg": 3689,
	"./24-25/noi_24-25/Rebecca Brown.jpg": 953,
	"./24-25/noi_24-25/Romana Haluskova.jpg": 2550,
	"./24-25/noi_24-25/Sandra Haluskova.jpg": 8479,
	"./24-25/noi_24-25/Schneider Kata.jpg": 6660,
	"./24-25/noi_24-25/Szalai Szonja.jpg": 6207,
	"./24-25/noi_24-25/Szederkényi Lilla.jpg": 7095,
	"./24-25/noi_24-25/Sághy Lara.jpg": 9020,
	"./24-25/noi_24-25/Torontáli Anna.jpg": 4254,
	"./24-25/noi_24-25/Vass Szonja.jpg": 7758,
	"./24-25/noi_24-25/Zaka Norbert.jpg": 2003,
	"./24-25/noi_24-25/team.jpg": 8523,
	"./U16/Adorján Csomai Milán.jpg": 8200,
	"./U16/Belényesi András.jpg": 6027,
	"./U16/Boda Márton.jpg": 4847,
	"./U16/Boros Barnabás.jpg": 2673,
	"./U16/Csakmag Zalán.jpg": 8963,
	"./U16/Ficzere Márton.jpg": 7059,
	"./U16/Gál Konrád.jpg": 8231,
	"./U16/Jobb Hunor.jpg": 5957,
	"./U16/Keserű Kolos.jpg": 3581,
	"./U16/Kiss Csongor.jpg": 8715,
	"./U16/Kiss Erik.jpg": 8539,
	"./U16/Kovács Patrik.jpg": 1658,
	"./U16/Kovács Péter Áron.jpg": 9961,
	"./U16/Majoross Barnabás.jpg": 3130,
	"./U16/Meggyes Medárd.jpg": 5044,
	"./U16/Menyhárt Martin.jpg": 7803,
	"./U16/Nagy Alex.jpg": 5497,
	"./U16/Nagy Dániel.jpg": 6980,
	"./U16/Nádasy Bertalan.jpg": 8777,
	"./U16/Papp Dániel.jpg": 4122,
	"./U16/Popov Novak.jpg": 4799,
	"./U16/Somogyi Balázs.jpg": 3172,
	"./U16/Soós Gergő.jpg": 8920,
	"./U16/Szabó Péter.jpg": 2495,
	"./U16/Sztolbunov Ádám.jpg": 9025,
	"./U16/Tomkó Márton.jpg": 1851,
	"./U16/Vigh Szilveszter.jpg": 1897,
	"./U16/Vincze Botond.jpg": 6271,
	"./U16/team.jpg": 2885,
	"./U18/Armuth Máté.jpg": 3564,
	"./U18/Bencic Mihajlo.jpg": 7898,
	"./U18/Betic Ronen.jpg": 2899,
	"./U18/Boroznaki Kadosa.jpg": 4400,
	"./U18/Bánvölgyi Bálint.jpg": 3542,
	"./U18/Drexler Hugó.jpg": 981,
	"./U18/Góbi Péter.jpg": 9259,
	"./U18/Gödény Zalán.jpg": 5357,
	"./U18/Halász Márk.jpg": 6348,
	"./U18/Husti Csanád.jpg": 4507,
	"./U18/Jászai Barna.jpg": 4998,
	"./U18/Kemény-Savovic Milán.jpg": 3724,
	"./U18/Kállay Mihály.jpg": 5274,
	"./U18/Kóródi Zalán.jpg": 9678,
	"./U18/Körtvélyessy Botond.jpg": 8639,
	"./U18/Matti Pylkas.jpg": 8588,
	"./U18/Mihályi Olivér.jpg": 9036,
	"./U18/Relja Brestovac.jpg": 175,
	"./U18/Tajti Dániel.jpg": 5893,
	"./U18/Tornyos Benedek.jpg": 8000,
	"./U18/Tóth Kristóf.jpg": 2097,
	"./U18/Urbányi Krisztián.jpg": 4727,
	"./U18/Vónya-Tolner Ákos.jpg": 9504,
	"./U18/team.jpg": 9099,
	"./U18/Ábrahám Gábor.jpg": 8027,
	"./U21/Balogh Áron.jpg": 6135,
	"./U21/Bánhegyi Szabolcs.jpg": 4438,
	"./U21/Daradics Ákos.jpg": 5543,
	"./U21/Dobos Boldizsár.jpg": 9781,
	"./U21/Fockter Kadosa.jpg": 8011,
	"./U21/Kajner Botond.jpg": 4957,
	"./U21/Kornyilov Péter.jpg": 9919,
	"./U21/Kovács Szabolcs.jpg": 2382,
	"./U21/Káté Zoltán.jpg": 3049,
	"./U21/Ladányi Balázs.jpg": 4216,
	"./U21/Lakatos Levente.jpg": 7654,
	"./U21/Marton Attila.jpg": 804,
	"./U21/Player Placeholder.jpg": 2188,
	"./U21/Sava Lifshits.jpg": 5621,
	"./U21/Schmidt Barnabás.jpg": 6578,
	"./U21/Szabó István.jpg": 4360,
	"./U21/Szalontai-Virág István.jpg": 1638,
	"./U21/Szamel Barnabás.jpg": 4910,
	"./U21/Szlovicsák Balázs.jpg": 378,
	"./U21/Szécsi Viktor.jpg": 4106,
	"./U21/Temunovic Vanja.jpg": 1122,
	"./U21/Tóth Flórián.jpg": 6364,
	"./U21/Varga Ákos.jpg": 2743,
	"./U21/Zsitva Gergely.jpg": 8490,
	"./U21/team.jpg": 4635,
	"./noi/Bereczki Blanka.jpg": 6212,
	"./noi/Bátyi Boróka.jpg": 2505,
	"./noi/Gyula Rebeka.jpg": 480,
	"./noi/Görbe Liza.jpg": 2006,
	"./noi/Haraszt Lorina.jpg": 2970,
	"./noi/Kerkovits Réka.jpg": 2607,
	"./noi/Kiss Andrea.jpg": 5241,
	"./noi/Kosztya Laura.jpg": 794,
	"./noi/Lazic Ivona.jpg": 7504,
	"./noi/Player Placeholder.jpg": 4200,
	"./noi/Procházka Ana Karolina.jpg": 3802,
	"./noi/Puskás Noémi.jpg": 7851,
	"./noi/Regine Carlotta.jpg": 1392,
	"./noi/Schneider Kata.jpg": 8792,
	"./noi/Szalai Szonja.jpg": 9419,
	"./noi/Szederkényi Lilla.jpg": 755,
	"./noi/Szilágyi Levente.jpg": 1787,
	"./noi/Szilágyi Tifani.jpg": 2049,
	"./noi/Sághy Lara.jpg": 1976,
	"./noi/Torontáli Anna.jpg": 9418,
	"./noi/Vass Szonja.jpg": 6090,
	"./noi/team.jpg": 1135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;